import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';
import { NibrasToastComponent } from './nibras-toast.component';

@NgModule({
  imports: [CommonModule, ToastrModule],
  declarations: [NibrasToastComponent],
  exports: [NibrasToastComponent]
})
export class NibrasToastModule {}
